export { default } from './containers/LanguageSwitcher';
